import { getLegacyStore } from '@beef/legacy-beeline-store';
export default getLegacyStore();